import { Action, createReducer, on } from '@ngrx/store';
import { UserState, UserInitialState } from './user.state';
import { UserActions } from './user.actions';

const _userReducer = createReducer(
  UserInitialState,
  on(UserActions.initUser, state => ({ ...state, update: true })),
  on(UserActions.setUser, (state, { user }) => ({
    ...state,
    user,
  })),
  on(UserActions.stopUpdate, state => ({ ...state, update: false }))
);

export function userReducer(state: UserState, action: Action): UserState {
  return _userReducer(state, action);
}
